import React, { useState, useEffect } from 'react';
import styles from '../../styles/AdmisionEstudiantesStyles/AdmisionEstudiantes.module.css';
import { getInstitutions } from '../../api/institutions';
import { getCampus } from '../../api/campus';
import { getPrograms } from '../../api/programs';
import { getCycles } from '../../api/ciclosEscolares';

function NewStudentModal({ onClose, onSave, editMode = false, studentData = null }) {
  const [activeTab, setActiveTab] = useState('datos-personales');
  const [instituciones, setInstituciones] = useState([]);
  const [campusList, setCampusList] = useState([]);
  const [programas, setProgramas] = useState([]);
  const [ciclos, setCiclos] = useState([]);
  
  const [formData, setFormData] = useState({
    // Datos Personales
    nombreCompleto: '',
    institucion: '',
    campus: '',
    matricula: '',
    curp: '',
    fechaNacimiento: '',
    lugarNacimiento: '',
    sexo: '',
    estadoCivil: '',
    nacionalidad: '',
    paisOrigen: '',
    emailPersonal: '',
    emailInstitucional: '',
    telefonoPrincipal: '',
    telefonoEmergencia: '',
    contactoEmergencia: '',
    estatusEstudiante: '',
    
    // Domicilio
    calleNumero: '',
    colonia: '',
    ciudad: '',
    estado: '',
    codigoPostal: '',
    pais: '',
    
    // Información Académica
    programa: '',
    cicloEscolar: '',
    periodoInicial: '',
    promedioProce: '',
    institucionProcedencia: '',
    tipoIngreso: '',
    
    // Expediente
    documentos: [
      { nombre: 'INE', fecha: '15/10/2025, 10:43', acciones: ['subir'] },
      { nombre: 'CURP', fecha: '02/08/2025, 09:12', acciones: ['ver', 'eliminar'] },
      { nombre: 'Comprobante de domicilio', fecha: '22/11/2024, 15:03', acciones: ['ver', 'eliminar'] },
      { nombre: 'Certificado de Estudios', fecha: '15/10/2025, 10:43', acciones: ['subir'] }
    ]
  });

  useEffect(() => {
    const loadDropdownData = async () => {
      try {
        const [instData, campusData, programsData, ciclosData] = await Promise.all([
          getInstitutions(),
          getCampus(),
          getPrograms(),
          getCycles()
        ]);
        setInstituciones(instData || []);
        setCampusList(campusData || []);
        setProgramas(programsData || []);
        setCiclos(ciclosData || []);
      } catch (error) {
        console.error('Error loading dropdown data:', error);
      }
    };
    loadDropdownData();
  }, []);

  useEffect(() => {
    if (editMode && studentData) {
      const getIdValue = (value, objectKey) => {
        if (value && typeof value === 'object') {
          return value[objectKey] ?? '';
        }
        return value ?? '';
      };

      const convertToLocalDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      };

      setFormData({
        nombreCompleto: studentData.nombre_completo || '',
        institucion: getIdValue(studentData.id_institucion, 'id_institucion'),
        campus: getIdValue(studentData.id_campus, 'id_campus'),
        matricula: studentData.matricula || '',
        curp: studentData.curp || '',
        fechaNacimiento: convertToLocalDate(studentData.fecha_nacimiento),
        lugarNacimiento: studentData.lugar_nacimiento || '',
        sexo: studentData.sexo || '',
        estadoCivil: studentData.estado_civil || '',
        nacionalidad: studentData.nacionalidad || '',
        paisOrigen: studentData.pais_origen || '',
        emailPersonal: studentData.email_personal || '',
        emailInstitucional: studentData.email_institucional || '',
        telefonoPrincipal: studentData.telefono_principal || '',
        telefonoEmergencia: studentData.telefono_emergencia || '',
        contactoEmergencia: studentData.contacto_emergencia || '',
        estatusEstudiante: studentData.estatus_estudiante || '',
        
        calleNumero: studentData.calle || '',
        colonia: studentData.colonia || '',
        ciudad: studentData.ciudad || '',
        estado: studentData.estado || '',
        codigoPostal: studentData.codigo_postal || '',
        pais: studentData.pais || '',
        
        programa: getIdValue(studentData.id_programa_actual, 'id_programa'),
        cicloEscolar: getIdValue(studentData.ciclo_ingreso, 'id_ciclo_escolar'),
        periodoInicial: studentData.periodo_inicial || '',
        promedioProce: studentData.promedio_procedencia || '',
        institucionProcedencia: studentData.institucion_procedencia || '',
        tipoIngreso: studentData.tipo_ingreso || '',
        
        documentos: [
          { nombre: 'INE', fecha: '15/10/2025, 10:43', acciones: ['subir'] },
          { nombre: 'CURP', fecha: '02/08/2025, 09:12', acciones: ['ver', 'eliminar'] },
          { nombre: 'Comprobante de domicilio', fecha: '22/11/2024, 15:03', acciones: ['ver', 'eliminar'] },
          { nombre: 'Certificado de Estudios', fecha: '15/10/2025, 10:43', acciones: ['subir'] }
        ]
      });
    }
  }, [editMode, studentData]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  const renderDatosPersonales = () => (
    <div className={styles.tabContent}>
      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Nombre Completo del Estudiante</label>
          <input
            type="text"
            className={styles.formInput}
            value={formData.nombreCompleto}
            onChange={(e) => handleInputChange('nombreCompleto', e.target.value)}
          />
        </div>
      </div>
      
      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Institución</label>
          <select 
            className={styles.formSelect}
            value={formData.institucion}
            onChange={(e) => handleInputChange('institucion', e.target.value)}
          >
            <option value="">– Seleccionar institución –</option>
            {instituciones.map(inst => (
              <option key={inst.id} value={inst.id}>{inst.name}</option>
            ))}
          </select>
        </div>
        
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Campus</label>
          <select 
            className={styles.formSelect}
            value={formData.campus}
            onChange={(e) => handleInputChange('campus', e.target.value)}
          >
            <option value="">– Seleccionar un campus –</option>
            {campusList.map(c => (
              <option key={c.id} value={c.id}>{c.nombre}</option>
            ))}
          </select>
        </div>
      </div>
      
      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Matrícula</label>
          <input
            type="text"
            className={styles.formInput}
            value={formData.matricula}
            onChange={(e) => handleInputChange('matricula', e.target.value)}
          />
        </div>
        
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>CURP</label>
          <input
            type="text"
            className={styles.formInput}
            value={formData.curp}
            onChange={(e) => handleInputChange('curp', e.target.value)}
          />
        </div>
      </div>
      
      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Fecha de nacimiento</label>
          <div className={styles.dateInputContainer}>
            <input
              type="text"
              className={styles.dateInput}
              value={formData.fechaNacimiento}
              onChange={(e) => handleInputChange('fechaNacimiento', e.target.value)}
            />
            <div className={styles.dateIcon}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
            </div>
          </div>
        </div>
        
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Lugar de nacimiento</label>
          <input
            type="text"
            className={styles.formInput}
            value={formData.lugarNacimiento}
            onChange={(e) => handleInputChange('lugarNacimiento', e.target.value)}
          />
        </div>
      </div>
      
      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Género</label>
          <select 
            className={styles.formSelect}
            value={formData.sexo}
            onChange={(e) => handleInputChange('sexo', e.target.value)}
          >
            <option value="">– Seleccionar género –</option>
            <option value="M">Masculino</option>
            <option value="F">Femenino</option>
            <option value="O">Otro</option>
          </select>
        </div>
        
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Estado civil</label>
          <select 
            className={styles.formSelect}
            value={formData.estadoCivil}
            onChange={(e) => handleInputChange('estadoCivil', e.target.value)}
          >
            <option value="">– Seleccionar estado civil –</option>
            <option value="soltero">Soltero(a)</option>
            <option value="casado">Casado(a)</option>
            <option value="divorciado">Divorciado(a)</option>
            <option value="viudo">Viudo(a)</option>
          </select>
        </div>
      </div>
      
      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Nacionalidad</label>
          <select 
            className={styles.formSelect}
            value={formData.nacionalidad}
            onChange={(e) => handleInputChange('nacionalidad', e.target.value)}
          >
            <option value="">– Seleccione país –</option>
            <option value="mexicana">Mexicana</option>
            <option value="estadounidense">Estadounidense</option>
          </select>
        </div>
        
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>País de Origen</label>
          <select 
            className={styles.formSelect}
            value={formData.paisOrigen}
            onChange={(e) => handleInputChange('paisOrigen', e.target.value)}
          >
            <option value="">– Seleccione país –</option>
            <option value="mexico">México</option>
            <option value="estados-unidos">Estados Unidos</option>
          </select>
        </div>
      </div>
      
      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Email personal</label>
          <input
            type="email"
            className={styles.formInput}
            value={formData.emailPersonal}
            onChange={(e) => handleInputChange('emailPersonal', e.target.value)}
          />
        </div>
        
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Email institucional</label>
          <input
            type="email"
            className={styles.formInput}
            value={formData.emailInstitucional}
            onChange={(e) => handleInputChange('emailInstitucional', e.target.value)}
          />
        </div>
      </div>
      
      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Teléfono principal</label>
          <input
            type="tel"
            className={styles.formInput}
            value={formData.telefonoPrincipal}
            onChange={(e) => handleInputChange('telefonoPrincipal', e.target.value)}
          />
        </div>
        
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Teléfono de emergencia</label>
          <input
            type="tel"
            className={styles.formInput}
            value={formData.telefonoEmergencia}
            onChange={(e) => handleInputChange('telefonoEmergencia', e.target.value)}
          />
        </div>
      </div>
      
      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Contacto de emergencia</label>
          <input
            type="text"
            className={styles.formInput}
            value={formData.contactoEmergencia}
            onChange={(e) => handleInputChange('contactoEmergencia', e.target.value)}
          />
        </div>
        
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Estatus del Estudiante</label>
          <select 
            className={styles.formSelect}
            value={formData.estatusEstudiante}
            onChange={(e) => handleInputChange('estatusEstudiante', e.target.value)}
          >
            <option value="">– Seleccionar –</option>
            <option value="ACTIVO">Activo</option>
            <option value="BAJA_TEMPORAL">Baja Temporal</option>
            <option value="BAJA_DEFINITIVA">Baja Definitiva</option>
            <option value="EGRESADO">Egresado</option>
            <option value="NO_INSCRITO">No inscrito</option>
            <option value="PASANTE">Pasante</option>
          </select>
        </div>
      </div>
    </div>
  );

  const renderDomicilio = () => (
    <div className={styles.tabContent}>
      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Calle y número</label>
          <input
            type="text"
            className={styles.formInput}
            value={formData.calleNumero}
            onChange={(e) => handleInputChange('calleNumero', e.target.value)}
          />
        </div>
        
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Colonia</label>
          <input
            type="text"
            className={styles.formInput}
            value={formData.colonia}
            onChange={(e) => handleInputChange('colonia', e.target.value)}
          />
        </div>
      </div>
      
      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Ciudad</label>
          <input
            type="text"
            className={styles.formInput}
            value={formData.ciudad}
            onChange={(e) => handleInputChange('ciudad', e.target.value)}
          />
        </div>
        
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Estado</label>
          <select 
            className={styles.formSelect}
            value={formData.estado}
            onChange={(e) => handleInputChange('estado', e.target.value)}
          >
            <option value="">– Seleccionar –</option>
            <option value="aguascalientes">Aguascalientes</option>
            <option value="baja-california">Baja California</option>
            <option value="cdmx">Ciudad de México</option>
          </select>
        </div>
      </div>
      
      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Código Postal</label>
          <input
            type="text"
            className={styles.formInput}
            value={formData.codigoPostal}
            onChange={(e) => handleInputChange('codigoPostal', e.target.value)}
          />
        </div>
        
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>País</label>
          <select 
            className={styles.formSelect}
            value={formData.pais}
            onChange={(e) => handleInputChange('pais', e.target.value)}
          >
            <option value="">– Seleccionar –</option>
            <option value="mexico">México</option>
            <option value="estados-unidos">Estados Unidos</option>
          </select>
        </div>
      </div>
    </div>
  );

  const renderInformacionAcademica = () => (
    <div className={styles.tabContent}>
      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Programa</label>
          <select 
            className={styles.formSelect}
            value={formData.programa}
            onChange={(e) => handleInputChange('programa', e.target.value)}
          >
            <option value="">– Selecciona un programa –</option>
            {programas.map(prog => (
              <option key={prog.id} value={prog.id}>{prog.name}</option>
            ))}
          </select>
        </div>
        
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Ciclo escolar de ingreso</label>
          <select 
            className={styles.formSelect}
            value={formData.cicloEscolar}
            onChange={(e) => handleInputChange('cicloEscolar', e.target.value)}
          >
            <option value="">– Selecciona un ciclo –</option>
            {ciclos.map(c => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>
      </div>
      
      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Período inicial</label>
          <input
            type="text"
            className={styles.formInput}
            value={formData.periodoInicial}
            onChange={(e) => handleInputChange('periodoInicial', e.target.value)}
          />
        </div>
        
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Institución de procedencia</label>
          <input
            type="text"
            className={styles.formInput}
            value={formData.institucionProcedencia}
            onChange={(e) => handleInputChange('institucionProcedencia', e.target.value)}
          />
        </div>
      </div>
      
      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Promedio de procedencia</label>
          <input
            type="text"
            className={styles.formInput}
            value={formData.promedioProce}
            onChange={(e) => handleInputChange('promedioProce', e.target.value)}
          />
        </div>
        
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Tipo de ingreso</label>
          <select 
            className={styles.formSelect}
            value={formData.tipoIngreso}
            onChange={(e) => handleInputChange('tipoIngreso', e.target.value)}
          >
            <option value="">– Seleccionar –</option>
            <option value="NUEVO">Nuevo Ingreso</option>
            <option value="REINGRESO">Reingreso</option>
            <option value="TRANSFERENCIA">Transferencia</option>
          </select>
        </div>
      </div>
    </div>
  );

  const renderExpediente = () => (
    <div className={styles.tabContent}>
      <div className={styles.expedienteTable}>
        <div className={styles.expedienteHeader}>
          <div className={styles.expedienteHeaderCell}>Documento</div>
          <div className={styles.expedienteHeaderCell}>Fecha de actualización</div>
          <div className={styles.expedienteHeaderCell}>Acciones</div>
        </div>
        
        <div className={styles.expedienteBody}>
          {formData.documentos.map((doc, index) => (
            <div key={index} className={styles.expedienteRow}>
              <div className={styles.expedienteCell}>{doc.nombre}</div>
              <div className={styles.expedienteCell}>{doc.fecha}</div>
              <div className={styles.expedienteCell}>
                <div className={styles.expedienteActions}>
                  {doc.acciones.includes('subir') && (
                    <button className={styles.uploadButton}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                        <polyline points="7,10 12,15 17,10"/>
                        <line x1="12" y1="15" x2="12" y2="3"/>
                      </svg>
                      Subir Archivo
                    </button>
                  )}
                  {doc.acciones.includes('ver') && (
                    <button className={styles.viewButton}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                    </button>
                  )}
                  {doc.acciones.includes('eliminar') && (
                    <button className={styles.deleteButton}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M3 6h18"/>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                      </svg>
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const renderTabContent = () => {
    switch (activeTab) {
      case 'datos-personales':
        return renderDatosPersonales();
      case 'domicilio':
        return renderDomicilio();
      case 'informacion-academica':
        return renderInformacionAcademica();
      case 'expediente':
        return renderExpediente();
      default:
        return renderDatosPersonales();
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>{editMode ? 'Editar Estudiante' : 'Nuevo Estudiante'}</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        
        <div className={styles.modalTabs}>
          <button 
            className={`${styles.tab} ${activeTab === 'datos-personales' ? styles.tabActive : ''}`}
            onClick={() => setActiveTab('datos-personales')}
          >
            Datos Personales
          </button>
          <button 
            className={`${styles.tab} ${activeTab === 'domicilio' ? styles.tabActive : ''}`}
            onClick={() => setActiveTab('domicilio')}
          >
            Domicilio
          </button>
          <button 
            className={`${styles.tab} ${activeTab === 'informacion-academica' ? styles.tabActive : ''}`}
            onClick={() => setActiveTab('informacion-academica')}
          >
            Información Académica
          </button>
          <button 
            className={`${styles.tab} ${activeTab === 'expediente' ? styles.tabActive : ''}`}
            onClick={() => setActiveTab('expediente')}
          >
            Expediente
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className={styles.modalForm}>
          <div className={styles.modalContent}>
            {renderTabContent()}
          </div>
          
          <div className={styles.modalActions}>
            <div className={styles.modalActionsLeft}>
              <button type="button" className={styles.credentialButton}>
                📄 Generar Credencial
              </button>
              <button type="button" className={styles.expedientButton}>
                👁️ Ver Expediente
              </button>
            </div>
            <div className={styles.modalActionsRight}>
              <button type="button" className={styles.cancelButton} onClick={onClose}>
                CANCELAR
              </button>
              <button type="submit" className={styles.saveButton}>
                GUARDAR
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default NewStudentModal;
